<template>
  <LandingBackground>
    <PublicLandingHeader
      :title="'Distributor Reporting OSWM Platform'"
      subtitle="Hawaii State Environmental Health Administration Solid and Hazardous Waste Branch"
    />

    <PublicLandingContainer class="grid justify-stretch md:justify-center 2xl:max-w-screen-2xl">
      <PublicLandingBackdrop class="grid grid-cols-1 gap-10 2xl:col-span-2 2xl:grid-cols-2">
        <PublicLandingOnlineServices
          class="2xl:col-span-2"
          title="Online Services"
          body="The Distributor Reporting OSWM Platform (DROP) offers online access to Office of Solid Waste Management beverage distributor services. Distributors can submit monthly and semi-annual distributor reports, and maintain a company product list."
        ></PublicLandingOnlineServices>

        <PublicLandingCard>
          <PublicLandingCardSection label="Monthly Distributor Reports">
            <PublicLandingParagraph
              >For beverage distributors who annually import or distribute more than 100,000 deposit beverage
              containers</PublicLandingParagraph
            >
            <PublicLandingList>
              <PublicLandingListItem label="Submit monthly distributor reports" />
              <PublicLandingListItem label="View historical report submissions" />
            </PublicLandingList>
          </PublicLandingCardSection>

          <PublicLandingCardSection label="Semi-Annual Distributor Reports">
            <PublicLandingParagraph
              >For beverage distributors who annually import or distribute 100,000 or fewer deposit beverage
              containers</PublicLandingParagraph
            >
            <PublicLandingList>
              <PublicLandingListItem label=" Submit semi-annual distributor reports" />
              <PublicLandingListItem label="View historical report submissions" />
            </PublicLandingList>
          </PublicLandingCardSection>
        </PublicLandingCard>

        <PublicLandingCard>
          <PublicLandingCardSection label="Distributor Product Lists">
            <PublicLandingParagraph
              >Update the brands and sizes of each type of deposit beverage containers
              distributed</PublicLandingParagraph
            >
            <PublicLandingList>
              <PublicLandingListItem label="View company product list" />
              <PublicLandingListItem label="Submit product list changes" />
            </PublicLandingList>
          </PublicLandingCardSection>
          <PublicLandingCardSection label="Resources">
            <!-- <PublicLandingParagraph></PublicLandingParagraph> -->
            <PublicLandingList>
              <PublicLandingListItem
                ><a class="text-sky-600 hover:underline" href="https://health.hawaii.gov/hi5/" target="_blank"
                  >Hawaii Deposit Beverage Container Program
                </a></PublicLandingListItem
              >
              <PublicLandingListItem
                ><a
                  class="text-sky-600 hover:underline"
                  href="https://health.hawaii.gov/hi5/files/2021/09/FAQInOutAug2023.pdf"
                  target="_blank"
                  >Frequently Asked Questions - What's In? and What's Out?
                </a></PublicLandingListItem
              >
              <PublicLandingListItem
                ><a
                  class="text-sky-600 hover:underline"
                  href="https://health.hawaii.gov/hi5/files/2013/05/dist_FAQLabel.pdf"
                  target="_blank"
                  >Frequently Asked Questions - Labeling
                </a></PublicLandingListItem
              >
              <PublicLandingListItem
                ><a
                  class="text-sky-600 hover:underline"
                  href="https://health.hawaii.gov/hi5/files/2013/05/HawaiiAdminRules1.pdf"
                  target="_blank"
                  >Hawaii Administrative Rules - Deposit Beverage Container Recycling
                </a></PublicLandingListItem
              >
              <PublicLandingListItem
                ><a
                  class="text-sky-600 hover:underline"
                  href="https://www.capitol.hawaii.gov/hrscurrent/Vol06_Ch0321-0344/HRS0342G/HRS_0342G-.htm"
                  target="_blank"
                  >Hawaii Revised Statutes - Integrated Solid Waste Management
                </a></PublicLandingListItem
              >
            </PublicLandingList>
          </PublicLandingCardSection>
        </PublicLandingCard>
      </PublicLandingBackdrop>
    </PublicLandingContainer>

    <MdrnFooter light black-and-white />
  </LandingBackground>
</template>

<script lang="ts">
import LandingBackground from "@/components/LandingBackground.vue";
import { routeNames } from "@/routes";
import { InitialBadge } from "@modernary/mui/components/badge";
import { BaseButton } from "@modernary/mui/components/button";
import { MdrnFooter, NoneFoundFlag, useAppNav, useAppSettingsStore } from "@modernary/mui/components/common";
import {
  PublicLandingBackdrop,
  PublicLandingCard,
  PublicLandingCardSection,
  PublicLandingContainer,
  PublicLandingHeader,
  PublicLandingLinkCard,
  PublicLandingList,
  PublicLandingListItem,
  PublicLandingOnlineServices,
  PublicLandingParagraph,
} from "@modernary/mui/components/publicLanding";
import { LoginButton, LogoutButton, RegisterButton } from "@modernary/mui/utils/authentication/buttons";
import { computed, defineComponent } from "vue";

// Home content for unauth'd users
export default defineComponent({
  name: "HomePublic",
  components: {
    BaseButton,
    InitialBadge,
    LoginButton,
    RegisterButton,
    MdrnFooter,
    NoneFoundFlag,
    LogoutButton,
    LandingBackground,
    PublicLandingCard,
    PublicLandingCardSection,
    PublicLandingList,
    PublicLandingListItem,
    PublicLandingParagraph,
    PublicLandingLinkCard,
    PublicLandingOnlineServices,
    PublicLandingHeader,
    PublicLandingContainer,
    PublicLandingBackdrop,
  },
  setup() {
    const appSettingsStore = useAppSettingsStore();

    return { BaseButton, appSettingsStore, routeNames };
  },
});
</script>

<style lang="css" module></style>
